// this is an autogenerated file from App/Account/WaitingRoom/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_WaitingRoom_Content(
  $location_id: uuid!
  $local_start_date: date!
) {
  appointments_agenda_view(
    where: {
      location_id: { _eq: $location_id }
      local_start_date: { _eq: $local_start_date }
    }
  ) {
    id
    _id
    state
    start_time
    local_start_date
    local_start_time
    check_in_time
    provider_id
    assistant_id
    chair_id
    chair_code
    patient_id
    patient_person
    appointment_id
    appointment_type
    has_notes
    confirmation_status
  }
}

`